import {getJourneysService} from '../services/journeysService'
import {GetJourneysResponse} from '../types/Journeys'

export type GetJourneysUseCaseParams = {
  page?: number
  size?: number
  sort?: string
}

export type GetJourneysFilters = {
  status?: string
  type?: string
  name?: string
  publishedBy?: string
  createdOnStart?: string
  createdOnEnd?: string
  modifiedOnStart?: string
  modifiedOnEnd?: string
  publishedOnStart?: string
  publishedOnEnd?: string
}

export const DEFAULT_SORT = 'createdAt,desc'

export const DEFAULT_PAGE_SIZE = 10

export async function getJourneysUseCase(
  params?: GetJourneysUseCaseParams & GetJourneysFilters,
  signal?: AbortSignal
): Promise<GetJourneysResponse> {
  const {page = 0, size = DEFAULT_PAGE_SIZE, sort = DEFAULT_SORT, ...columnsFilters} = params || {}
  return getJourneysService({page, size, sort, ...columnsFilters}, signal)
}
